/**
 * Global API Error Event Bus
 * Allows API error interceptors to emit errors that are caught by components
 */

const listeners = new Set();

export const apiErrorBus = {
  /**
   * Emit an API error message to all listeners
   * @param {string} message - Error message to display
   */
  emit: (message) => {
    listeners.forEach(fn => fn(message));
  },

  /**
   * Subscribe to API errors
   * @param {Function} callback - Function to call when error is emitted
   * @returns {Function} Unsubscribe function
   */
  subscribe: (callback) => {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },
};
